// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
}

;(function () {
  BoostPFS.inject(this)

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function () {
    var suggestionElement = this.$uiMenuElement
    var searchElement = this.$element
    var searchBoxId = this.id
  }

  InstantSearchApi.beforeCall = function (searchTerm) {
    Globals.instantSearchQueryParams.currency = boostPFSConfig.general.current_currency.toLowerCase()
    Globals.instantSearchQueryParams.currency_rate = Shopify.currency.rate
    Globals.instantSearchQueryParams.return_all_currency_fields = false
  }
  Utils.convertPriceBasedOnActiveCurrency = function (price, isRounded = true) {
    if (!price || price == 0) return price
    if (Utils.isEnableShopifyMultipleCurrencies()) {
      var convertPrice = price * Shopify.currency.rate
      if (isRounded) {
        price = Utils.roundedPrice(convertPrice)
      } else {
        price = convertPrice
      }
    }
    return parseFloat(price)
  }
  Utils.isShopifyActiveCurrency = function () {
    return false
  }
  Utils.isEnableShopifyMultipleCurrencies = function () {
    return false
  }
})()
